import React from "react";
import { ColorCardsContainer } from "./ColorCardsLayout.styles";

const ColorCardsLayout = ({ children }) => {
    return <ColorCardsContainer>{children}</ColorCardsContainer>;
};

export default ColorCardsLayout;
